import React from 'react'
import withStyles from '@mui/styles/withStyles'
import { styles } from 'components/atoms/link'
import type { ReactNode } from 'react'

type Props = {
  to: string;
  target: string;
  classes: any;
  children: Array<ReactNode> | ReactNode;
};

const ExternalLink = React.forwardRef((props: Props, ref) => {
  const { to, classes, target = '_blank', ...linkProps } = props
  return (
    <a
// @ts-expect-error - TS2322 - Type 'ForwardedRef<unknown>' is not assignable to type 'LegacyRef<HTMLAnchorElement> | undefined'.
      ref={ref}
      className={classes.root}
      href={to}
      target={target}
      rel='nofollow noreferrer noopener'
      {...linkProps}
    >{linkProps.children}</a>
  )
})

export default withStyles(styles)(ExternalLink)
